import React from "react";
import ServicesPage from '../components/services/ServicesPage'
import OurServices from '../components/services/OurServices'


function Services() {
  return (
    <div>
      <ServicesPage />

      <OurServices />
   
    </div>
  );
}

export default Services;
